module.exports = __webpack_public_path__ + "static/media/13.06bb884c.mp3";